// extracted by mini-css-extract-plugin
export default {"wrapper":"Input_wrapper__LhkEv","disabled":"Input_disabled__qWN2K","input":"Input_input__8MAWS","label":"Input_label__BxvMU","count":"Input_count__7mSA6"};